
import React from 'react';
import HumanityClub from 'views/Human2020';

const HumanityClubPage = () => {
  return <HumanityClub />;
};

export default HumanityClubPage;